import React from 'react';
import KPICard from '../../components/shared/KPICard';
import StatusPill from '../../components/shared/StatusPill';
import SectionDivider from '../../components/shared/SectionDivider';
import { pgvclKPIs, pgvclImportExportData, varianceAlerts } from '../../data/mockData';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

export default function DiscomNetMetering() {
  return (
    <div className="p-6 space-y-6">
      <div className="flex gap-4">
        <KPICard title="Import This Month" value={`${pgvclKPIs.importMWh} MWh`} subtext="Apr 2026" />
        <KPICard title="Export This Month" value={`${pgvclKPIs.exportMWh} MWh`} subtext="Apr 2026" subtextColor="green" />
        <KPICard title="Rising Demand" value={`${pgvclKPIs.risingDemandMW} MW`} subtext="Peak demand hours" subtextColor="amber" bgColor="bg-orange-50" />
        <KPICard title="Grid Failure Events" value={pgvclKPIs.gridFailureEvents} bgColor="bg-red-50" subtextColor="red" subtext="This month" />
        <KPICard title="Tamper Count" value={pgvclKPIs.tamperCount} bgColor="bg-orange-50" subtextColor="amber" subtext="Flagged for inspection" />
      </div>

      <div className="bg-white rounded-card border border-border shadow-card p-4">
        <SectionDivider title="Import vs Export — PGVCL" subtitle="Monthly MWh (Nov 2025 – Apr 2026)" />
        <ResponsiveContainer width="100%" height={240}>
          <BarChart data={pgvclImportExportData} margin={{ top: 8, right: 16, left: 0, bottom: 4 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#EEEEEE" vertical={false} />
            <XAxis dataKey="month" tick={{ fontSize: 11, fill: '#999999' }} axisLine={false} tickLine={false} />
            <YAxis tick={{ fontSize: 11, fill: '#999999' }} axisLine={false} tickLine={false} />
            <Tooltip
              contentStyle={{ fontSize: 12, borderRadius: 6, border: '1px solid #DDDDDD' }}
              formatter={(val: unknown, name: unknown) => [`${val} MWh`, name === 'import' ? 'Import' : 'Export']}
            />
            <Legend
              iconType="square"
              iconSize={10}
              wrapperStyle={{ fontSize: 12, paddingTop: 8 }}
              formatter={(v) => v === 'import' ? 'Import (MWh)' : 'Export (MWh)'}
            />
            <Bar dataKey="import" fill="#B52020" radius={[3, 3, 0, 0]} maxBarSize={28} />
            <Bar dataKey="export" fill="#1A6B3A" radius={[3, 3, 0, 0]} maxBarSize={28} />
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="bg-white rounded-card border border-border shadow-card p-4">
        <SectionDivider title="Variance Alerts" subtitle="Plants with inverter vs meter variance &gt;5%" />
        <table className="w-full text-xs">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left py-2.5 text-text-tertiary font-medium">Plant ID</th>
              <th className="text-left py-2.5 text-text-tertiary font-medium">Consumer</th>
              <th className="text-right py-2.5 text-text-tertiary font-medium">Inverter kWh</th>
              <th className="text-right py-2.5 text-text-tertiary font-medium">Meter kWh</th>
              <th className="text-right py-2.5 text-text-tertiary font-medium">Variance%</th>
              <th className="text-center py-2.5 text-text-tertiary font-medium">Status</th>
            </tr>
          </thead>
          <tbody>
            {varianceAlerts.map(v => (
              <tr key={v.plantId} className={`border-b border-border/50 hover:bg-bg-secondary cursor-pointer ${v.status === 'REVIEW' ? 'bg-orange-50/30' : ''}`}>
                <td className="py-2.5 font-mono text-text-primary">{v.plantId}</td>
                <td className="py-2.5 text-text-secondary">{v.consumerName}</td>
                <td className="py-2.5 text-right text-text-secondary">{v.inverterKWh}</td>
                <td className="py-2.5 text-right text-text-secondary">{v.meterKWh}</td>
                <td className={`py-2.5 text-right font-semibold ${v.variancePercent > 5 ? 'text-warning' : 'text-success'}`}>{v.variancePercent}%</td>
                <td className="py-2.5 text-center">
                  <StatusPill status={v.status === 'REVIEW' ? 'review' : 'clear'} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
